var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopSettingsPage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 7.02892 4.00212 6.40121 4.06431 5.9387C4.12262 5.50496 4.21677 5.36902 4.29289 5.29289C4.36902 5.21677 4.50496 5.12262 4.9387 5.06431C5.40121 5.00212 6.02892 5 7 5H17C17.9711 5 18.5988 5.00212 19.0613 5.06431C19.495 5.12262 19.631 5.21677 19.7071 5.29289C19.7832 5.36902 19.8774 5.50496 19.9357 5.9387C19.9979 6.40121 20 7.02892 20 8V16H4V8Z",
    stroke: "#D4D4D4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66667 16C2.74619 16 2 16.7462 2 17.6667C2 18.9553 3.04467 20 4.33333 20H19.6667C20.9553 20 22 18.9553 22 17.6667C22 16.7462 21.2538 16 20.3333 16H3.66667Z",
    stroke: "#D4D4D4",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopSettingsPage);
export default __webpack_public_path__ + "static/media/desktop_settings_page.4b6b555b0d21c48139d18482faa9fbaf.svg";
export { ForwardRef as ReactComponent };